<template>

  <div style="text-align: center;margin-top: 50px">
    <button class="switch" @click="switchFlagFE">FrontEnd Integration</button>
    <button class="switch" @click="switchFlagBE">BackEnd Integration</button>
    <div v-if="this.switch">
      <p>
        <button> 1 </button> install our NPM package.You need to check its presence in package.json file
      </p>
      <p>
      <textarea class="step1" >
      npm install authupays
      </textarea>
        <button class="btn" id="installCopy" @click="copyClipboard(this.step1,0)" >
          <i class="fa fa-clone" aria-hidden="true"></i>
        </button>
      </p>
      <p>
        <button> 2 </button> Insert the following JS function into the component file where the authentication process is performed - customize it for your case
      </p>
      <p>
    <textarea class="step2" id="code">
    function authenticateCustomer() {

      const upaysServer = {

        url: 'https://upays-server-031285db46a4.herokuapp.com',
        signEndPoint: '/ckeys/auth',
        authEndPoint: '/ckeys/verify',
      }
      const client = {

        /* your UPAYS ACCESS KEY  64-digit */

        businessKey:'13c61...de2fd',

        /* your CUSTOMER KEY 64-digit  */
        /* generated by UPAYS when completed payment */

        customerKey:'2080....e5bb93',

        auth:{
          username: 'mee is a symbol',
          password: 'just support him'
        }
      }
      upaysAuth(client,localServer).then( result => {

        /* AUTHENTICATION RESULT - true or false */
        console.log(result)
        /* your code that handles authentication */

      }).catch(error => {

        /*  AUTHENTICATE ERROR */
        console.log(error)
      })
    }
    </textarea>
        <button id="codeCopy" @click="copyClipboard(this.step2,1)" class="btn">
          <i class="fa fa-clone" aria-hidden="true"></i>
        </button>
      </p>
    </div>
    <div v-else>
      <p>
        Please contact support!<br>
        We will send you a software solution based on your BE framework / platform
      </p>
    </div>
    <br>
    <button class="close" @click="close">Back</button>
    <br><br>
  </div>
</template>
<script>
export default {
  name: "IntegrateAuth",
  data() {
    return {
      key:'',
      step1:'npm install authupays',
      step2:'',
      switch:true, // means fe integration
    }
  },
  mounted() {
    this.key = this.$route.params.code
    const txt = document.getElementById('code')
    this.step2 = txt.innerHTML.replaceAll('&gt;','>')
  },
  methods:{
    switchFlagFE() {
      this.switch = true
    },
    switchFlagBE() {
      this.switch = false
    },
    close() {
      const key = localStorage.getItem('akey')
      if(key) {
        this.$router.push('/configurator') // automate sign in after  fee payment
      }else {
        this.$router.go(-1)   //trail client , payed client after sign in
      }
    },
    copyClipboard(value,type){
      const textSpinning = [
        { transform: "rotate(0) scale(1)" },
        { transform: "rotate(360deg) scale(0)" },
      ];
      const textTiming = {
        duration: 2000,
        iterations: 1,
      };
      navigator.clipboard.writeText(`${value}`).then( () => {
        let copyBtn = document.getElementById("installCopy");
        if(type === 1){
          copyBtn = document.getElementById('codeCopy')
        }
        copyBtn.animate(textSpinning, textTiming);
      })
    },
  }
}
</script>
<style scoped>
@import "../assets/buttons.css";

textarea {
  background-color: black;
  border-radius: 10px;
  border-color: white;
  width: 30%;
  margin-top: 5px;
  font-size: 12px;
  padding: 10px;
  color: white;
}

.step1 {
  height: 50px;
}

.step2 {
  height: 290px;
  width: 40%;
}
.btn {
  padding: 5px 5px;
  border-radius: 5px;
  border: none;
  opacity: 0.5;
  background-color: lightgrey;
  color: black;
}
.btn:hover {
  opacity: 0.9;
}

p {
  animation-duration: 3s;
  animation-name: slide-in;
  animation-iteration-count: 1;
  animation-direction: alternate;
  font-size: 16px;
}
@keyframes slide-in {
  from {
    translate: 150vw 0;
    scale: 200% 1;
  }
  to {
    translate: 0 0;
    scale: 100% 1;
  }
}
.switch {
  padding: 10px 30px;
  background-color: lightsteelblue;
  opacity: 0.6;
  cursor: pointer;
  border-radius: 10px;
  border: white 1px solid;
}
.switch:hover{
  opacity: 0.9;
}
@media screen and (max-width: 430px) {
  textarea {
    font-size: 10px;
  }
  .step1 {
    width: 85%;
  }
  .step2 {
    width: 85%;
  }
  p {
    font-size: 13px;
  }
}
</style>